module.exports = __webpack_public_path__ + "static/media/roros.d2eae6c4.jpg";